import AppStyledTemplate from "App/appStyledTemplate";
import React, { useEffect } from "react";
import ErrorPanel from "../errorPanel/errorPanel";
import { useParams } from "react-router-dom";
import removeInitLoader from "Common/loader/removeInitLoader";
export default function ErrorPage() {
    const { code, title } = useParams();
    useEffect(() => {
        removeInitLoader();
    }, []);
    return (React.createElement(AppStyledTemplate, null,
        React.createElement("div", { className: "w-100 h-100vh d-flex" },
            React.createElement(ErrorPanel, { code: code, title: title }))));
}
